import { createElement, registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { Action } from "../Actions/Action";
import { IAction } from "../Actions/IAction";
import { DropDownMenuItem } from "./DropDownMenuItem";

export class DropDownMenuItemFlag extends DropDownMenuItem {
    private _color: string;

    public static createDropDownMenuItemFlag(func: () => Promise<void>, locKey: string, color?: string, enabled: boolean = false, priority: number = 15, locParams?: string[]): DropDownMenuItemFlag {
        const element = new DropDownMenuItemFlag();
        element._color = color;
        element._init(element, undefined, new Action(func, locKey, locParams), locKey, enabled, priority, locParams);
        return element;
    }

    public override _init(element: DropDownMenuItem, icon: string, action: IAction, locKey: string, enabled?: boolean, priority?: number, locParams?: string[]): void {
        super._init(element, icon, action, locKey, enabled, priority, locParams);
        this._createFlagElement();
    }

    protected override _createIconElement(): void {
        // Prazdna metoda
    }

    protected _createFlagElement(): void {
        if (!this._color)
            this._color = "";
        this.insertAdjacentElement("afterbegin", createElement({ classes: ["flag", this._color] }));
    }
}

registerCustomElement("tsc-DropDownMenuItemFlag", DropDownMenuItemFlag);
